import { AppRoot } from '@telegram-apps/telegram-ui'

// The app is dark-only (see docs/superpowers/specs/2026-07-06-catalog-feed-redesign-design.md).
// index.html hardcodes class="dark" and telegram/init.ts paints Telegram's own
// chrome (header/background/bottom bar) dark. This just forces the TGUI palette,
// the same in-Telegram and in the browser admin.
export function TelegramProvider({ children }: { children: React.ReactNode }) {
	return (
		<AppRoot appearance='dark' platform='base'>
			{children}
		</AppRoot>
	)
}
